import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AddUserInbox as AddUserInboxMutation,
    AddUserInboxVariables as AddUserInboxVariables,
    UserInboxAddInput,
} from 'nutshell-graphql-types';

import ADD_USER_INBOX from '../mutations/add-user-inbox.graphql';
import GET_USER_INBOXES from '../queries/get-user-inboxes.graphql';

export const useAddUserInbox = (): {
    addUserInbox: (arg1: UserInboxAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [addUserInbox, {loading, error}] = useMutation<
        AddUserInboxMutation,
        AddUserInboxVariables
    >(ADD_USER_INBOX);

    return {
        addUserInbox: (input: UserInboxAddInput) => {
            return addUserInbox({
                variables: {input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'Mutation',
                    userInboxAdd: {
                        __typename: 'UserInboxAddPayload',
                        user: {
                            __typename: 'User',
                            id: input.userId,
                        },
                    },
                },
                update: (proxy, mutationResults) => {
                    const newUser =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.userInboxAdd &&
                        mutationResults.data.userInboxAdd.user;

                    if (newUser) {
                        const cacheResult = proxy.readQuery({
                            query: GET_USER_INBOXES,
                            variables: {threadType: input.threadType},
                        });

                        if (cacheResult) {
                            proxy.writeQuery({
                                query: GET_USER_INBOXES,
                                variables: {threadType: input.threadType},
                                // @ts-expect-error
                                data: {userInboxes: [...cacheResult.userInboxes, newUser]},
                            });
                        }
                    }
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
